import { api } from "../../api/fetch";

export const fetchTestSpecifications = async (testSuiteId: number) => {
    return await api.get(`/api/v1/test-suites/${testSuiteId}/tests`);
}